import type { ICreateOfferCmd } from "@/data/commands/catalog/CreateOfferCmd";
import { Factory } from "@/data/dao/Factory";
import { CatalogDao } from "@/data/dao/service/CatalogDao";
import type { IOffer } from "@/data/model/Offer";

import { BaseEntityForm } from "@/portal/forms/BaseEntityForm";

export class OfferForm extends BaseEntityForm<IOffer, ICreateOfferCmd> {
    private $nameField: JQuery;
    private $internalNoteField: JQuery;

    constructor(element: JQuery) {
        super(element, Factory.getInstance<CatalogDao>(CatalogDao).offerDataSource);

        this.$nameField = this.$form
            .find('.form-control[name="name"]')
            .change(() => this.updateName(this.$nameField.val()));
        this.$internalNoteField = this.$form.find('.form-control[name="internalnote"]');
    }

    public setFormData(model?: IOffer) {
        this.updateName(model === undefined ? "" : model.name);
        this.$nameField.val(model === undefined ? "" : model.name);
        this.$internalNoteField.val(model === undefined || model.internalNote === undefined ? "" : model.internalNote);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public getFormData($form: JQuery): ICreateOfferCmd {
        const data: ICreateOfferCmd = {
            name: this.$nameField.val().length === 0 ? undefined : this.$nameField.val(),
            internalNote: this.$internalNoteField.val().length === 0 ? undefined : this.$internalNoteField.val(),
        };

        let hasError = false;
        if (data.name === undefined || data.name.length > 128) {
            hasError = true;
            this.$nameField.addClass("is-invalid");
        }

        return (hasError ? undefined : data) as any;
    }
}
